import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Pentagon = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="75" viewBox="0 0 75 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.3661 0.221771L0.28894 27.1594L14.4509 70.7453H60.2803L74.4422 27.1594L37.3661 0.221771Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
